import React from "react";
import { AnalyticsListener } from "@atlaskit/analytics-next";
import QrcodeComponent from "@atlassiansox/bxpkit-qrcode";
import tracking from '../../../utils/tracking';

const sendAnalytics = analytic => {
  const eventName =
    analytic.payload && analytic.payload.name
      ? analytic.payload.name
      : "qrcode-component-track-event";

  let eventPayload = analytic.payload;
  if (analytic.context[0]) {
    eventPayload = Object.assign(analytic.context[0], analytic.payload);
  }

  if (eventPayload.name !== undefined) {
    delete eventPayload.name;
  }

  try {
    tracking.trackEvent(eventName, eventPayload);
  } catch (e) {
    console.log(eventName, "AnalyticsListener did not find tracker");
  }
};

const QrcodeComponentContainer = ({
  size,
  value,
  iconSrc,
  iconSize,
}) => {
  return (
    <AnalyticsListener onEvent={sendAnalytics}>
      <QrcodeComponent
        size={size}
        value={value}
        iconSrc={iconSrc}
        iconSize={iconSize}
      />
    </AnalyticsListener>
  );
};

export default QrcodeComponentContainer;
